import { Pagination } from "@elastic/eui";

export interface PaginationOptions {
  pageSizeOptions?: number[];
  initialPageIndex?: number;
  initialPageSize?: number;
  pageIndex: number;
  pageSize: number;
  totalItemCount?: number;
}

export const paginationBase: Pagination = {
  pageSizeOptions: [20, 50, 100],
  pageIndex: 0,
  pageSize: 20,
  totalItemCount: 0,
};
